import queryString from "query-string";

const initialTab = () => {
  ["turbo:load", "turbo:render"].forEach((event) => {
    document.addEventListener(event, () => {
      const queryParams = queryString.parse(location.search);
      const items = document.querySelectorAll(".nav-tabs > li > a");
      if (items.length <= 0) return;

      const contents = document.querySelectorAll(".tab-content > div");
      if (contents.length <= 0) return;

      const tab = Number(queryParams.tab ?? 0);

      items[tab].classList.add("active");
      contents[tab].classList.add("show");
      contents[tab].classList.add("active");
    });
  });
};

export default initialTab;
